import React, { useState, useMemo } from "react";
import api from "../../../services/api";
import { PERIODOS_HORARIOS } from "../../../shared/constants";
import { fmtDateFull, todayISO } from "../../../shared/utils";
export default function Agendamentos(props) {
  let currentStudent = props.currentStudent;
  let salas = props.salas;
  let agendamentos = props.agendamentos;
  let setAgendamentos = props.setAgendamentos;
  let bloqueios = props.bloqueios;
  let students = props.students;
  let showFlash = props.showFlash;
  const [aba, setAba] = useState("novo");
  const [data, setData] = useState(todayISO());
  const [periodo, setPeriodo] = useState("");
  const [salaId, setSalaId] = useState(null);
  const [convidados, setConvidados] = useState([""]);
  const [ciente, setCiente] = useState(false);
  const [salasDisp, setSalasDisp] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isBloqueado = (targetSalaId, targetData, targetPeriodo) => {
    const diaSemana = new Date(targetData + "T12:00:00").getDay();
    return bloqueios.some((b) => {
      const salaCond =
        b.sala_id == null ||
        b.sala_id === "" ||
        Number(b.sala_id) === Number(targetSalaId);
      const perCond = !b.periodo || String(b.periodo) === String(targetPeriodo);
      if (b.tipo === "unico")
        return salaCond && perCond && b.data_especifica === targetData;
      if (b.tipo === "recorrente")
        return (
          salaCond && perCond && Number(b.dia_semana) === Number(diaSemana)
        );
      return false;
    });
  };
  const getBloqueioInfo = (targetSalaId, targetData, targetPeriodo) => {
    const diaSemana = new Date(targetData + "T12:00:00").getDay();
    return (
      bloqueios.find((b) => {
        const salaCond =
          b.sala_id == null ||
          b.sala_id === "" ||
          Number(b.sala_id) === Number(targetSalaId);
        const perCond =
          !b.periodo || String(b.periodo) === String(targetPeriodo);
        if (b.tipo === "unico") {
          return salaCond && perCond && b.data_especifica === targetData;
        }
        if (b.tipo === "recorrente") {
          return (
            salaCond && perCond && Number(b.dia_semana) === Number(diaSemana)
          );
        }
        return false;
      }) || null
    );
  };
  const salasDisponiveis = useMemo(
    () =>
      salasDisp
        ? salas.map((sala) => {
            const bloqueio = getBloqueioInfo(sala.id, data, periodo);
            const salaBloqueada =
              Boolean(bloqueio) || isBloqueado(sala.id, data, periodo);
            const agendamentosFiltrados = agendamentos.filter(
              (agendamento) =>
                agendamento.sala_id === sala.id &&
                agendamento.data === data &&
                agendamento.periodo === periodo &&
                "confirmado" === agendamento.status,
            );
            const vagasOcupadas = agendamentosFiltrados.length;
            return {
              ...sala,
              bloqueada: salaBloqueada,
              bloqueioMotivo: bloqueio?.motivo || null,
              ocupadas: vagasOcupadas,
              vagas: sala.capacidade - vagasOcupadas,
              ags: agendamentosFiltrados,
            };
          })
        : null,
    [salasDisp, salas, agendamentos, bloqueios, data, periodo],
  );
  if (!currentStudent) return null;
  const agendamentoExistente = agendamentos.find(
    (agendamento) =>
      agendamento.aluno_id === currentStudent.id &&
      agendamento.data === data &&
      agendamento.periodo === periodo &&
      "confirmado" === agendamento.status &&
      !agendamento.convidado,
  );
  const meusAgendamentos = agendamentos
    .filter((agendamento) => agendamento.aluno_id === currentStudent.id)
    .sort(
      (left, right) =>
        right.data.localeCompare(left.data) || right.criado_em - left.criado_em,
    );
  const minData = todayISO();
  const maxData = new Date(Date.now() + 6048e5).toISOString().slice(0, 10);
  const isDataAgendamentoValida = (dataAgendamento) =>
    !!/^\d{4}-\d{2}-\d{2}$/.test(String(dataAgendamento || "")) &&
    dataAgendamento >= minData &&
    dataAgendamento <= maxData;
  const convValidos = convidados
    .map((convidado) => convidado.trim())
    .filter((item) => item.length > 0);
  const totalVagas = 1 + convValidos.length;
  const cancelarAgendamento = async (agendamento) => {
    if ((new Date(agendamento.data + "T12:00:00") - Date.now()) / 36e5 < 24) {
      showFlash(
        "Atenção: cancelamento com menos de 24h pode gerar multa de R$10.",
        "wa",
      );
    }
    try {
      if (!agendamento.convidado) {
        const afetados = agendamentos.filter(
          (agendamentoRelacionado) =>
            agendamentoRelacionado.aluno_id === agendamento.aluno_id &&
            agendamentoRelacionado.sala_id === agendamento.sala_id &&
            agendamentoRelacionado.data === agendamento.data &&
            agendamentoRelacionado.periodo === agendamento.periodo &&
            "confirmado" === agendamentoRelacionado.status,
        );
        let updates = [];
        try {
          const updatesRaw =
            (
              await api.put("/agendamentos/lote", {
                items: afetados.map((item) => ({
                  ...item,
                  status: "cancelado",
                })),
              })
            ).data?.data ?? [];
          updates = Array.isArray(updatesRaw) ? updatesRaw : [updatesRaw];
        } catch (err) {
          if (![404, 405].includes(err.response?.status)) throw err;
          updates = await Promise.all(
            afetados.map(async (item) => {
              const res = await api.put("/agendamentos?id=".concat(item.id), {
                ...item,
                status: "cancelado",
              });
              return res.data?.data ?? res.data;
            }),
          );
        }
        const byId = new Map(updates.map((update) => [update.id, update]));
        setAgendamentos((prev) =>
          prev.map((prevId) => byId.get(prevId.id) || prevId),
        );
        showFlash("Agendamento cancelado (você e seus convidados).", "in");
        return;
      }
      const responseData4 = await api.put(
        "/agendamentos?id=".concat(agendamento.id),
        {
          ...agendamento,
          status: "cancelado",
        },
      );
      const saved = responseData4.data?.data ?? responseData4.data;
      setAgendamentos((prev) =>
        prev.map((prevId) => (prevId.id === agendamento.id ? saved : prevId)),
      );
      showFlash(
        'Convidado "'.concat(agendamento.convidado, '" cancelado.'),
        "in",
      );
    } catch (err) {
      showFlash(
        err.response?.data?.message ||
          "Nao foi possivel cancelar o agendamento.",
        "er",
      );
    }
  };
  const statusCor = {
    confirmado: "#E0F5F0",
    cancelado: "#FFE5E0",
  };
  const statusTxt = {
    confirmado: "Confirmado",
    cancelado: "Cancelado",
  };
  const periodoLabel = (periodoAtual2) => {
    return (
      PERIODOS_HORARIOS.find(
        (periodoAtual3) => periodoAtual3.id === periodoAtual2,
      )?.label || periodoAtual2
    );
  };
  const grupos = [];
  const vistos = new Set();
  meusAgendamentos.forEach((meusAgendamentosData) => {
    const key = ""
      .concat(meusAgendamentosData.data, "|")
      .concat(meusAgendamentosData.periodo, "|")
      .concat(meusAgendamentosData.sala_id);
    if (vistos.has(key)) return;
    vistos.add(key);
    const grupo = meusAgendamentos.filter(
      (meusAgendamentosData2) =>
        meusAgendamentosData2.data === meusAgendamentosData.data &&
        meusAgendamentosData2.periodo === meusAgendamentosData.periodo &&
        meusAgendamentosData2.sala_id === meusAgendamentosData.sala_id,
    );
    const principal =
      grupo.find((grupoConvidado) => !grupoConvidado.convidado) || grupo[0];
    grupos.push({
      key,
      principal,
      convidadosGrupo: grupo.filter(
        (grupoConvidado) => grupoConvidado.convidado,
      ),
      todos: grupo,
    });
  });
  return (
    <div className={"cn"}>
      <h1 className={"pt"}>
        <em>{"Agendamentos"}</em>
      </h1>
      <div className={"ps"}>{"Reserve sua sala de estudo"}</div>
      <div className={"tabs"}>
        {[
          ["novo", "+ Novo Agendamento"],
          ["meus", "Meus Agendamentos"],
        ].map((item) => {
          const [resultado, setValue] = item;
          return (
            <button
              className={aba === resultado ? "a" : ""}
              onClick={() => setAba(resultado)}
              key={resultado}
            >
              {setValue}
            </button>
          );
        })}
      </div>
      {"novo" === aba && (
        <div className={"fc"}>
          <div
            style={{
              fontWeight: 800,
              color: "#1F4754",
              fontSize: 15,
              marginBottom: 14,
            }}
          >
            {"Novo Agendamento"}
          </div>
          <div className={"fg"}>
            <label>{"Data do Agendamento *"}</label>
            <input
              type={"date"}
              className={"inp"}
              value={data}
              min={minData}
              max={maxData}
              onChange={(event) => {
                setData(event.target.value);
                setSalasDisp(null);
                setSalaId(null);
              }}
            />
            <div
              style={{
                fontSize: 11,
                color: "#6B8590",
                marginTop: 3,
              }}
            >
              {"Disponivel nos próximos 7 dias"}
            </div>
          </div>
          <div className={"fg"}>
            <label>{"Período *"}</label>
            <select
              className={"sel"}
              value={periodo}
              onChange={(event) => {
                setPeriodo(event.target.value);
                setSalasDisp(null);
                setSalaId(null);
              }}
            >
              <option value={""}>{"Selecione um período"}</option>
              {PERIODOS_HORARIOS.map((periodoAtual2) => (
                <option value={periodoAtual2.id} key={periodoAtual2.id}>
                  {periodoAtual2.label}
                </option>
              ))}
            </select>
          </div>
          <div className={"fg"}>
            <label
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span>{"Convidados (opcional)"}</span>
              <span
                style={{
                  fontSize: 10,
                  color: "#6B8590",
                  fontWeight: 400,
                }}
              >
                {"Cada convidado ocupa 1 vaga"}
              </span>
            </label>
            {convidados.map((conv, index) => (
              <div
                style={{
                  display: "flex",
                  gap: 7,
                  marginBottom: 7,
                  alignItems: "center",
                }}
                key={index}
              >
                <input
                  className={"inp"}
                  type={"text"}
                  value={conv}
                  onChange={(event) =>
                    ((indexItem, indexAtual2) =>
                      setConvidados((prev) =>
                        prev.map((convItem, idx) =>
                          idx === indexItem ? indexAtual2 : convItem,
                        ),
                      ))(index, event.target.value)
                  }
                  placeholder={"Nome do convidado ".concat(index + 1)}
                  autoComplete={"off"}
                  style={{
                    flex: 1,
                    margin: 0,
                  }}
                />
                {convidados.length > 1 && (
                  <button
                    type={"button"}
                    onClick={() =>
                      ((indexItem) =>
                        setConvidados((prev) =>
                          prev.filter((prevItem, idx) => idx !== indexItem),
                        ))(index)
                    }
                    style={{
                      background: "#FFE5E0",
                      border: "none",
                      borderRadius: 8,
                      width: 34,
                      height: 42,
                      cursor: "pointer",
                      color: "#D9534F",
                      fontSize: 18,
                      fontWeight: 700,
                      flexShrink: 0,
                    }}
                  >
                    {"x"}
                  </button>
                )}
              </div>
            ))}
            <button
              type={"button"}
              onClick={() => setConvidados((prev) => [...prev, ""])}
              style={{
                background: "#F4F8F9",
                border: "1.5px dashed #B8C5CC",
                borderRadius: 9,
                padding: "9px 14px",
                width: "100%",
                cursor: "pointer",
                color: "#6B8590",
                fontSize: 13,
                fontWeight: 600,
                fontFamily: "inherit",
                marginTop: 2,
              }}
            >
              {"+ Adicionar outro convidado"}
            </button>
            <div
              style={{
                fontSize: 11,
                color: "#6B8590",
                marginTop: 6,
              }}
            >
              {
                "Deixe em branco se vier sozinho. Convidados trazidos contam no seu ranking!"
              }
            </div>
          </div>
          {totalVagas > 1 && (
            <div
              style={{
                background: "#F4F8F9",
                borderRadius: 9,
                padding: "9px 13px",
                marginBottom: 10,
                border: "1px solid #D5DEE3",
                fontSize: 13,
                color: "#1F4754",
              }}
            >
              {"Reservando "}
              <strong>
                {totalVagas}
                {" vagas"}
              </strong>
              {": você +"} {convValidos.length}
              {" convidado(s)"}
            </div>
          )}
          <div
            style={{
              background: "#E8F8F5",
              border: "1.5px solid #4FB3A9",
              borderRadius: 10,
              padding: "12px 14px",
              marginBottom: 14,
            }}
          >
            <label
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: 10,
                cursor: "pointer",
                margin: 0,
              }}
            >
              <input
                type={"checkbox"}
                checked={ciente}
                onChange={(event) => setCiente(event.target.checked)}
                style={{
                  marginTop: 3,
                  flexShrink: 0,
                }}
              />
              <span
                style={{
                  fontSize: 13,
                  color: "#1F4754",
                  lineHeight: 1.5,
                }}
              >
                {
                  "Estou ciente de que, se faltar e não cancelar com antecedencia, pagarei uma multa de"
                }{" "}
                <strong
                  style={{
                    color: "#FF8C42",
                  }}
                >
                  {"R$ 10,00"}
                </strong>
                {" por agendamento."}
              </span>
            </label>
          </div>
          <button
            className={"btn btn-full"}
            onClick={() => {
              if (!data || !periodo) {
                showFlash("Informe data e período.", "er");
                return;
              }
              if (!isDataAgendamentoValida(data)) {
                showFlash(
                  "A data do agendamento deve estar entre hoje e os próximos 7 dias.",
                  "er",
                );
                return;
              }
              setSalasDisp([]);
              setSalaId(null);
            }}
            style={{
              marginBottom: salasDisp ? 14 : 0,
            }}
          >
            {"Buscar Salas Disponíveis"}
          </button>
          {agendamentoExistente && (
            <div
              role={"status"}
              style={{
                background: "#E0F5F0",
                borderRadius: 10,
                padding: "10px 14px",
                marginBottom: 12,
                color: "#1A7A6E",
                fontSize: 13,
              }}
            >
              {
                "Você já tem um agendamento neste dia e período. Cancele-o para agendar novamente."
              }
              <button
                type={"button"}
                className={"btn bg bs"}
                style={{
                  marginLeft: 8,
                }}
                onClick={() => setAba("meus")}
              >
                {"Ver meu agendamento"}
              </button>
            </div>
          )}
          {salasDisp && (
            <div>
              <div className={"dv light"}>
                <span>
                  {"Salas para "}
                  {fmtDateFull(data)}
                  {" - "}
                  {periodoLabel(periodo)}
                </span>
              </div>
              {salasDisponiveis.map((salaSelecionada) => {
                const selecionada = salaId === salaSelecionada.id;
                const semVagas = salaSelecionada.vagas < totalVagas;
                const cor = salaSelecionada.bloqueada
                  ? "#FFE5E0"
                  : semVagas
                    ? "#FFF3CD"
                    : selecionada
                      ? "#E0F5F0"
                      : "#FFF";
                const borda = salaSelecionada.bloqueada
                  ? "#D9534F"
                  : semVagas
                    ? "#F59E0B"
                    : selecionada
                      ? "#4FB3A9"
                      : "#E0E8EB";
                return (
                  <div
                    style={{
                      background: cor,
                      border: "2px solid ".concat(borda),
                      borderRadius: 12,
                      padding: "13px 14px",
                      marginBottom: 8,
                      cursor:
                        salaSelecionada.bloqueada || semVagas
                          ? "not-allowed"
                          : "pointer",
                    }}
                    onClick={() => {
                      if (!(salaSelecionada.bloqueada || semVagas)) {
                        setSalaId(salaSelecionada.id);
                      }
                    }}
                    key={salaSelecionada.id}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: 5,
                      }}
                    >
                      <div
                        style={{
                          fontWeight: 800,
                          color: "#1F4754",
                          fontSize: 14,
                        }}
                      >
                        {salaSelecionada.nome}
                      </div>
                      <span
                        style={{
                          fontSize: 10,
                          fontWeight: 800,
                          padding: "3px 10px",
                          borderRadius: 999,
                          background: salaSelecionada.bloqueada
                            ? "#D9534F"
                            : semVagas
                              ? "#F59E0B"
                              : "#4FB3A9",
                          color: "#FFF",
                        }}
                      >
                        {salaSelecionada.bloqueada
                          ? "Bloqueada"
                          : semVagas
                            ? "Sem vagas"
                            : "Disponivel"}
                      </span>
                    </div>
                    <div
                      style={{
                        fontSize: 12,
                        color: "#6B8590",
                      }}
                    >
                      {"Cap: "}
                      {salaSelecionada.capacidade}
                      {" | Ocupadas: "}
                      {salaSelecionada.ocupadas}
                      {"/"}
                      {salaSelecionada.capacidade}
                      {" |"}{" "}
                      <strong
                        style={{
                          color:
                            salaSelecionada.vagas >= totalVagas
                              ? "#1A7A6E"
                              : "#B8651E",
                        }}
                      >
                        {"Livres: "}
                        {salaSelecionada.vagas}
                        {totalVagas > 1
                          ? " (precisa de ".concat(totalVagas, ")")
                          : ""}
                      </strong>
                    </div>
                    {salaSelecionada.bloqueada && (
                      <div
                        style={{
                          marginTop: 6,
                          fontSize: 11,
                          fontWeight: 700,
                          color: "#B83A2E",
                        }}
                      >
                        {"Bloqueio administrativo"}
                        {salaSelecionada.bloqueioMotivo
                          ? ": ".concat(salaSelecionada.bloqueioMotivo)
                          : "."}
                      </div>
                    )}
                    {salaSelecionada.ags.length > 0 && (
                      <div
                        style={{
                          marginTop: 8,
                          background: "rgba(0,0,0,0.04)",
                          borderRadius: 8,
                          padding: "7px 10px",
                        }}
                      >
                        <div
                          style={{
                            fontSize: 11,
                            fontWeight: 700,
                            color: "#1F4754",
                            marginBottom: 4,
                          }}
                        >
                          {"Já agendados:"}
                        </div>
                        {salaSelecionada.ags.map((itemAtual2, index) => {
                          const aluno = (students || []).find(
                            (item) => item.id === itemAtual2.aluno_id,
                          );
                          return (
                            <div
                              style={{
                                fontSize: 11,
                                color: "#2A5868",
                                padding: "2px 0",
                              }}
                              key={index}
                            >
                              {itemAtual2.convidado
                                ? "- Convidado: ".concat(itemAtual2.convidado)
                                : "- ".concat(aluno?.nome || "Aluno")}
                            </div>
                          );
                        })}
                      </div>
                    )}
                    {selecionada && !salaSelecionada.bloqueada && !semVagas && (
                      <div
                        style={{
                          marginTop: 6,
                          fontSize: 11,
                          color: "#1A7A6E",
                          fontWeight: 700,
                        }}
                      >
                        {"Sala selecionada"}
                      </div>
                    )}
                  </div>
                );
              })}
              {salaId && (
                <button
                  className={"btn btn-full"}
                  disabled={isSubmitting || !!agendamentoExistente}
                  style={{
                    marginTop: 10,
                    background:
                      isSubmitting || agendamentoExistente
                        ? "#A0CFC9"
                        : "#4FB3A9",
                    fontSize: 15,
                    padding: "13px",
                    cursor:
                      isSubmitting || agendamentoExistente
                        ? "not-allowed"
                        : "pointer",
                    opacity: isSubmitting || agendamentoExistente ? 0.75 : 1,
                    transition: "background 0.2s, opacity 0.2s",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 8,
                  }}
                  onClick={async () => {
                    if (isSubmitting) return;
                    if (!ciente) {
                      showFlash("Confirme que está ciente da multa.", "er");
                      return;
                    }
                    if (!isDataAgendamentoValida(data)) {
                      showFlash(
                        "A data do agendamento deve estar entre hoje e os próximos 7 dias.",
                        "er",
                      );
                      return;
                    }
                    if (!salaId) {
                      showFlash("Selecione uma sala.", "er");
                      return;
                    }
                    const sala = salasDisponiveis.find(
                      (salaSelecionada) => salaSelecionada.id === salaId,
                    );
                    if (null !== sala && undefined !== sala && sala.bloqueada) {
                      showFlash(
                        sala.bloqueioMotivo
                          ? "Sala bloqueada: ".concat(sala.bloqueioMotivo)
                          : "Sala bloqueada para este dia/período.",
                        "er",
                      );
                      return;
                    }
                    if (!sala || sala.vagas < totalVagas) {
                      showFlash(
                        "Vagas insuficientes. Esta sala tem "
                          .concat(
                            sala?.vagas || 0,
                            " vaga(s), você precisa de ",
                          )
                          .concat(totalVagas, "."),
                        "er",
                      );
                      return;
                    }
                    if (
                      agendamentos.find(
                        (agendamento) =>
                          agendamento.aluno_id === currentStudent.id &&
                          agendamento.data === data &&
                          agendamento.periodo === periodo &&
                          "confirmado" === agendamento.status &&
                          !agendamento.convidado,
                      )
                    ) {
                      showFlash(
                        "Você já possui um agendamento confirmado neste dia e turno. Cancele-o antes de criar outro.",
                        "er",
                      );
                      return;
                    }
                    const agora = Date.now();
                    const novosPayload = [
                      {
                        aluno_id: currentStudent.id,
                        sala_id: salaId,
                        data,
                        periodo,
                        status: "confirmado",
                        convidado: null,
                        criado_em: agora,
                      },
                    ];
                    convValidos.forEach((nome, index) => {
                      novosPayload.push({
                        aluno_id: currentStudent.id,
                        sala_id: salaId,
                        data,
                        periodo,
                        status: "confirmado",
                        convidado: nome,
                        criado_em: agora + index + 1,
                      });
                    });
                    setIsSubmitting(true);
                    try {
                      let criados = [];
                      try {
                        const criadosRaw =
                          (
                            await api.post("/agendamentos/lote", {
                              items: novosPayload,
                            })
                          ).data?.data ?? [];
                        criados = Array.isArray(criadosRaw)
                          ? criadosRaw
                          : [criadosRaw];
                      } catch (err) {
                        if (![404, 405].includes(err.response?.status))
                          throw err;
                        const responses = await Promise.all(
                          novosPayload.map((payload) =>
                            api.post("/agendamentos", payload),
                          ),
                        );
                        criados = responses.map((res) => {
                          return res.data?.data ?? res.data;
                        });
                      }
                      setAgendamentos((prev) => [...prev, ...criados]);
                      showFlash(
                        convValidos.length > 0
                          ? "Agendamento confirmado! Você + ".concat(
                              convValidos.length,
                              " convidado(s).",
                            )
                          : "Agendamento confirmado!",
                      );
                      setSalasDisp(null);
                      setSalaId(null);
                      setConvidados([""]);
                      setCiente(false);
                      setAba("meus");
                    } catch (err) {
                      if (409 === err.response?.status) {
                        showFlash(
                          err.response?.data?.message ||
                            "Sala bloqueada para este dia/período. Escolha outra sala.",
                          "er",
                        );
                        return;
                      }
                      showFlash(
                        err.response?.data?.message ||
                          "Nao foi possivel confirmar o agendamento.",
                        "er",
                      );
                    } finally {
                      setIsSubmitting(false);
                    }
                  }}
                >
                  {isSubmitting ? (
                    <React.Fragment>
                      <span
                        style={{
                          display: "inline-block",
                          width: 14,
                          height: 14,
                          border: "2px solid #fff",
                          borderTopColor: "transparent",
                          borderRadius: "50%",
                          animation: "spin 0.7s linear infinite",
                        }}
                      />
                      {"Confirmando..."}
                    </React.Fragment>
                  ) : (
                    "Confirmar Agendamento"
                  )}
                </button>
              )}
              <style>
                {"@keyframes spin { to { transform: rotate(360deg); } }"}
              </style>
            </div>
          )}
        </div>
      )}
      {"meus" === aba && (
        <div>
          {(() => {
            const confirmadosAtivos = grupos.filter((grupo) =>
              grupo.todos.some(
                (todo) =>
                  "confirmado" === todo.status && todo.data >= todayISO(),
              ),
            );
            return confirmadosAtivos.length > 0 ? (
              <div
                style={{
                  background: "#E0F5F0",
                  border: "1.5px solid #4FB3A9",
                  borderRadius: 10,
                  padding: "10px 14px",
                  marginBottom: 14,
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                }}
              >
                <span
                  style={{
                    fontSize: 20,
                  }}
                >
                  {"📅"}
                </span>
                <div>
                  <div
                    style={{
                      fontWeight: 700,
                      color: "#1A7A6E",
                      fontSize: 13,
                    }}
                  >
                    {1 === confirmadosAtivos.length
                      ? "Você tem 1 agendamento ativo"
                      : "Você tem ".concat(
                          confirmadosAtivos.length,
                          " agendamentos ativos",
                        )}
                  </div>
                  <div
                    style={{
                      fontSize: 11,
                      color: "#2A7A6E",
                      marginTop: 2,
                    }}
                  >
                    {"Apenas 1 agendamento por turno é permitido"}
                  </div>
                </div>
              </div>
            ) : null;
          })()}
          {0 === grupos.length ? (
            <div className={"es"}>
              <h3>{"Nenhum agendamento ainda"}</h3>
              <p>{"Faca seu primeiro agendamento!"}</p>
              <button
                className={"btn"}
                style={{
                  marginTop: 12,
                }}
                onClick={() => setAba("novo")}
              >
                {"+ Agendar Agora"}
              </button>
            </div>
          ) : (
            grupos.map((grupo) => {
              let key = grupo.key;
              let principal = grupo.principal;
              let convidadosGrupo = grupo.convidadosGrupo;
              let todos = grupo.todos;
              const sala = salas.find(
                (salaId2) => salaId2.id === principal.sala_id,
              );
              const passado = principal.data < todayISO();
              const confirmados = todos.filter(
                (todo) => "confirmado" === todo.status,
              );
              const podeCancelar = confirmados.length > 0 && !passado;
              const status =
                confirmados.length > 0 ? "confirmado" : "cancelado";
              return (
                <div
                  style={{
                    background: "#FFF",
                    borderRadius: 12,
                    padding: "13px 14px",
                    marginBottom: 10,
                    boxShadow: "0 2px 8px rgba(0,0,0,.07)",
                    borderLeft: "4px solid ".concat(
                      "confirmado" === status ? "#4FB3A9" : "#D9534F",
                    ),
                  }}
                  key={key}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      marginBottom: 8,
                    }}
                  >
                    <div>
                      <div
                        style={{
                          fontWeight: 800,
                          color: "#1F4754",
                          fontSize: 14,
                        }}
                      >
                        {sala?.nome || "?"}
                      </div>
                      <div
                        style={{
                          fontSize: 12,
                          color: "#6B8590",
                          marginTop: 2,
                        }}
                      >
                        {fmtDateFull(principal.data)}
                        {" -"} {periodoLabel(principal.periodo)}
                      </div>
                    </div>
                    <span
                      style={{
                        fontSize: 10,
                        fontWeight: 800,
                        padding: "3px 9px",
                        borderRadius: 999,
                        background: statusCor[status] || "#F4F8F9",
                        color: "confirmado" === status ? "#1A7A6E" : "#B83A2E",
                        flexShrink: 0,
                        marginLeft: 8,
                      }}
                    >
                      {statusTxt[status] || status}
                    </span>
                  </div>
                  <div
                    style={{
                      background: "#F4F8F9",
                      borderRadius: 9,
                      padding: "8px 11px",
                      marginBottom: convidadosGrupo.length > 0 ? 6 : 0,
                    }}
                  >
                    <div
                      style={{
                        fontSize: 12,
                        color: "#2A5868",
                        fontWeight: 600,
                      }}
                    >
                      {"Você ("}
                      {currentStudent.nome.split(" ")[0]}
                      {")"}
                      {"cancelado" === principal.status && (
                        <span
                          style={{
                            color: "#D9534F",
                            fontSize: 10,
                            marginLeft: 6,
                          }}
                        >
                          {"(cancelado)"}
                        </span>
                      )}
                    </div>
                    {convidadosGrupo.map((convidadosGrupoConvidado, index) => (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginTop: 5,
                        }}
                        key={index}
                      >
                        <div
                          style={{
                            fontSize: 12,
                            color: "#8B5CF6",
                            fontWeight: 600,
                          }}
                        >
                          {"+ Convidado: "}
                          {convidadosGrupoConvidado.convidado}
                          {"cancelado" === convidadosGrupoConvidado.status && (
                            <span
                              style={{
                                color: "#D9534F",
                                fontSize: 10,
                                marginLeft: 6,
                              }}
                            >
                              {"(cancelado)"}
                            </span>
                          )}
                        </div>
                        {"confirmado" === convidadosGrupoConvidado.status &&
                          !passado && (
                            <button
                              onClick={() =>
                                cancelarAgendamento(convidadosGrupoConvidado)
                              }
                              style={{
                                background: "none",
                                border: "1px solid #D9534F",
                                borderRadius: 6,
                                padding: "2px 8px",
                                color: "#D9534F",
                                fontSize: 10,
                                cursor: "pointer",
                                fontFamily: "inherit",
                                flexShrink: 0,
                                marginLeft: 8,
                              }}
                            >
                              {"Cancelar"}
                            </button>
                          )}
                      </div>
                    ))}
                  </div>
                  {!passado && isDataAgendamentoValida(principal.data) && (
                    <button
                      type={"button"}
                      className={"btn bg btn-full"}
                      style={{
                        marginTop: 8,
                        fontSize: 12,
                      }}
                      onClick={() => {
                        setData(principal.data);
                        setPeriodo(principal.periodo);
                        setSalasDisp([]);
                        setSalaId(null);
                        setAba("novo");
                      }}
                    >
                      {"Ver salas deste período"}
                    </button>
                  )}
                  {podeCancelar && (
                    <button
                      className={"btn btn-full"}
                      style={{
                        background: "#D9534F",
                        marginTop: 6,
                        fontSize: 12,
                      }}
                      onClick={() => cancelarAgendamento(principal)}
                    >
                      {"Cancelar Tudo ("}
                      {confirmados.length}
                      {" vaga"}
                      {confirmados.length > 1 ? "s" : ""}
                      {")"}
                    </button>
                  )}
                </div>
              );
            })
          )}
        </div>
      )}
    </div>
  );
}
